<div class="chatbot-parent">
  <rgz-platforma-chatbot></rgz-platforma-chatbot>
</div>
